import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Suivi d'activité / suivi RH — clipboard avec checklist duotone */
export const HrTrackingIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Bande tête menthe */}
      <rect x="8.5" y="2.5" width="7" height="3.5" rx="1" fill="var(--equiply-icon-bg)" />
      {/* Clipboard */}
      <path
        d="M8 4.5H6.5A1.5 1.5 0 0 0 5 6v14.5A1.5 1.5 0 0 0 6.5 22h11a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H16"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Bande tête contour */}
      <rect x="8.5" y="2.5" width="7" height="3.5" rx="1" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Lignes checklist */}
      <path d="M8 11h8M8 14.5h5M8 18h6" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
      {/* Check sur la 1ère ligne */}
      <circle cx="17" cy="11" r="1" fill="var(--equiply-icon-fg)" />
    </svg>
  ),
);
HrTrackingIcon.displayName = "HrTrackingIcon";
